import { render } from "./NavbarButton.vue?vue&type=template&id=1d24de12"
import script from "./NavbarButton.vue?vue&type=script&lang=ts"
export * from "./NavbarButton.vue?vue&type=script&lang=ts"
script.render = render

export default script